var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("PermissionSimplePage", {
        attrs: { permission: _vm.hasPermissionEx("view") }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasPermissionEx("view"),
              expression: "hasPermissionEx('view')"
            }
          ],
          staticClass: "main-body"
        },
        [
          _c("div", { staticClass: "main-dialog" }, [
            _c(
              "div",
              { attrs: { id: "card-container" } },
              [
                _c("div", { staticClass: "input-form" }, [
                  _c("div", { staticClass: "card-design" }, [
                    _c("div", {}, [
                      _c("span", { staticClass: "text" }, [
                        _vm._v(_vm._s(_vm.$t("system.user.query")))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "all-forms" }, [
                        _c(
                          "div",
                          { staticClass: "form" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("monitor.loginUserText")) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "filter-item",
                              attrs: {
                                placeholder: _vm.$t("common.pleaseEnterText")
                              },
                              model: {
                                value: _vm.queryParameter.loginUser,
                                callback: function($$v) {
                                  _vm.$set(_vm.queryParameter, "loginUser", $$v)
                                },
                                expression: "queryParameter.loginUser"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("monitor.loginTimeText")) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("el-date-picker", {
                              staticClass: "filter-item",
                              attrs: {
                                clearable: "",
                                type: "datetimerange",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                "range-separator": "-",
                                "start-placeholder": _vm.$t("common.fromTime"),
                                "end-placeholder": _vm.$t("common.toTime")
                              },
                              model: {
                                value: _vm.queryParameter.loginTime,
                                callback: function($$v) {
                                  _vm.$set(_vm.queryParameter, "loginTime", $$v)
                                },
                                expression: "queryParameter.loginTime"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "searchButton" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "filter-item",
                            attrs: {
                              plain: _vm.$store.getters.plainConf,
                              type: "info",
                              icon: "el-icon-search"
                            },
                            on: { click: _vm.handleFilter }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("common.search")) +
                                "\n              "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasPermissionEx("view"),
                        expression: "hasPermissionEx('view')"
                      },
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.listLoading,
                        expression: "listLoading"
                      }
                    ],
                    key: _vm.tableKey,
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.list,
                      stripe: _vm.$store.getters.stripeConf,
                      border: _vm.$store.getters.borderConf
                    },
                    on: { "selection-change": _vm.handleSelectionChange }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("monitor.loginUserText"),
                        align: "center",
                        "min-width": "140"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: scope.row.username
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v(_vm._s(scope.row.username))]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("monitor.IPAddressText"),
                        align: "center",
                        "min-width": "140"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [_c("span", [_vm._v(_vm._s(scope.row.ip))])]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("monitor.loginLocationText"),
                        align: "center",
                        "min-width": "140"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: scope.row.location
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v(_vm._s(scope.row.location))]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("monitor.loginTimeText"),
                        align: "center",
                        "min-width": "140"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [_vm._v(_vm._s(scope.row.loginTime))])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("monitor.loginBrowserText"),
                        align: "center",
                        "min-width": "140"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: scope.row.browser
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v(_vm._s(scope.row.browser))]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("pagination", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hasPermissionEx("view"),
                      expression: "hasPermissionEx('view')"
                    }
                  ],
                  attrs: {
                    total: _vm.total,
                    page: _vm.queryParameter.pageNum,
                    limit: _vm.queryParameter.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.queryParameter, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.queryParameter, "pageSize", $event)
                    },
                    pagination: _vm.getList
                  }
                })
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }